// Module-level cache for the itinerary's per-activity booking statuses
// (tripId -> { data, ts }). Planner tabs unmount on switch, so without this
// every return to the itinerary refired GET /booking-status. Mutations write
// through via setBookingStatusesCached, so the cache is never staler than the
// user's own actions. Cleared at auth boundaries via invalidateSessionCaches
// so one account's booking flags can't render for the next account on the
// same device.

const bookingStatusCache = new Map();
const BOOKING_STATUS_TTL_MS = 60_000;

export const getBookingStatusesCached = (tripId) => {
  if (!tripId) return null;
  const entry = bookingStatusCache.get(tripId);
  if (!entry) return null;
  if (Date.now() - entry.ts > BOOKING_STATUS_TTL_MS) {
    bookingStatusCache.delete(tripId);
    return null;
  }
  return entry.data;
};

export const setBookingStatusesCached = (tripId, data) => {
  if (!tripId) return;
  bookingStatusCache.set(tripId, { data, ts: Date.now() });
};

export const invalidateBookingStatusCache = () => {
  bookingStatusCache.clear();
};
